module.exports = __webpack_public_path__ + "img/img9.16d2d1a1.png";